import React, { useEffect, useState } from "react";
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Card as MuiCard,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import OlogaPageHeader from "../../components/misc/OlogaPageHeader";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import OlogaDataGrid from "../../components/tables/OlogaDataGrid";
import OlogaDataTableNormal from "../../components/tables/OlogaDataTableNormal";
import { toast } from "react-toastify";
import { Formik } from "formik";
import OlogaTextfield from "../../components/inputfields/OlogaTextField";
import { OlogaButton } from "../../components/Buttons/OlogaButton";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../../utils/axios";
import RefreshIcon from "@mui/icons-material/Refresh";
import OlogaBackButton from "../../components/Buttons/OlogaBackButton";
import OlogaConfirmDialog from "../../components/misc/OlogaConfirmDialog";
import { dropdownDTO } from "../form_builder/data_mapping";
import http from "../../utils/axios";

const CandidateProgress: React.FC = () => {
  const Card = styled(MuiCard)(spacing);
  const navigate = useNavigate();
  const [url, setUrl] = useState("/candidate/levels/q");
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogDown, setOpenDialogDown] = useState(false);
  const [comment, setComment] = useState<string>("");
  const [params, setParams] = useState<any>();

  const [selectedProvince, setSelectedProvince] = useState<string | "">("");
  const [selectedSector, setSelectedSector] = useState<string | "">("");
  const [sectors, setSectors] = useState<dropdownDTO[]>([]);
  const [dropdown_province, setDropdown_province] = useState<dropdownDTO[]>([]);
  const [selectedName, setSelectedName] = useState<string | "">("");

  const columns: GridColDef[] = [
    {
      field: "fullName",
      headerName: "Nome Completo",
      flex: 1,
      editable: false,
    },
    {
      field: "nuit",
      headerName: "NUIT",
      flex: 1,
      editable: false,
    },
    {
      field: "category",
      headerName: "Categoria",
      flex: 1,
      editable: false,
    },
    {
      field: "dimension",
      headerName: "Dimensão",
      flex: 1,
      editable: false,
    },
    {
      field: "sector",
      headerName: "Sector de Actividade",
      flex: 1,
      editable: false,
    },
    {
      field: "levelStatus",
      headerName: "Estado de Nivel",
      flex: 1,
      editable: false,
    },
    {
      field: "actions",
      headerName: "Acções",
      flex: 2,
      editable: false,
      type: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<OlogaButton variant="outlined" label="Subir de Nivel" />}
          onClick={async () => {
            setParams(params);
            setOpenDialog(true);
          }}
          label="Subir de Nivel"
        />,
        <GridActionsCellItem
          icon={<OlogaButton variant="outlined" label="Baixar de Nivel" />}
          onClick={async () => {
            setParams(params);
            setOpenDialogDown(true);
          }}
          label="Baixar de Nivel"
        />,
      ],
    },
  ];

  const updateLevel = async (commentTmp: string) => {
    const response = await axios.post("candidate/levels/upgrade", {
      candidateId: params?.id,
      comment: commentTmp,
    });
    if (response.status === 200) {
      if (response.data === "") {
        toast.error(
          `Não existe um plano de acção para o candidato ${params?.row?.fullName}`
        );
      } else {
        toast.success(
          `Candidato ${params?.row?.fullName} subiu para o nível ${response.data?.level.code}`
        );
        navigate(`/candidates/progress`);
      }
    } else {
      toast.error(
        "Ocorreu o seguinte erro ao realizar a operação: " + response.data
      );
    }
    setOpenDialog(false);
    setComment("");
  };

  const downLevel = async (commentTmp: string) => {
    const response = await axios.post("candidate/levels/downgrade", {
      candidateId: params?.id,
      comment: commentTmp,
    });
    if (response.status === 200) {
      if (response.data === "") {
        toast.error(
          `Não existe um plano de acção para o candidato ${params?.row?.fullName}`
        );
      } else {
        toast.success(
          `Candidato ${params?.row?.fullName} desceu para o nível ${response.data?.level.code}`
        );
        navigate(`/candidates/progress`);
      }
    } else {
      toast.error(
        "Ocorreu o seguinte erro ao realizar a operação: " + response.data
      );
    }
    setOpenDialog(false);
    setComment("");
  };

  useEffect(() => {}, [url]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const ACTIVITY_SECTOR = await http.get(
          `simple-entity/findDropdown/ACTIVITY_SECTOR`
        );
        setSectors(ACTIVITY_SECTOR.data);

        const response = await http.get(`simple-entity/findDropdown/PROVINCE`);
        setDropdown_province(response.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, [url]);

  const handleSectorChange = (event: any) => {
    console.log(event.target.value);

    setSelectedSector(event.target.value);
  };

  const handleProvinceChange = (event: any) => {
    console.log(event.target.value);

    setSelectedProvince(event.target.value);
  };
  const handleSubmit = async (values: any) => {
    try {
      if (selectedName != "" || selectedName.length > 0) {
        values["candidateName"] = selectedName;
      }
      if (selectedSector != "" || selectedSector.length > 0) {
        values["activitySector"] = selectedSector;
      }
      if (selectedProvince != "" || selectedProvince.length > 0) {
        values["province"] = selectedProvince;
      }
      console.log(values);
      let q = "";

      for (let key in values) {
        if (values.hasOwnProperty(key)) {
          let value = values[key];
          if (value) {
            q += key + "=" + value + "&";
          }
        }
      }
      console.log("query", q);
      setUrl(
        q.length > 0
          ? "/candidate/levels/q?" + q.slice(0, -1)
          : "/candidate/levels/q"
      );
    } catch (error: any) {
      toast.error("Ocorreu o seguinte erro ao realizar a operação: " + error);
    }
  };
  return (
    <React.Fragment>
      <OlogaPageHeader
        title={"Listagem dos Beneficiários Pré-Seleccionados"}
      ></OlogaPageHeader>
      <Grid container>
        <Grid item xs={12}>
          <Formik initialValues={{}} enableReinitialize onSubmit={handleSubmit}>
            {({ handleSubmit, status }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={4} mb={3}>
                  <Grid item xs={12} md={3}>
                    <OlogaTextfield
                      name="candidateName"
                      label="Nome do Candidato"
                      // onChange={handleNameChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth variant="outlined" margin="normal">
                      <InputLabel>Sector de Actividade</InputLabel>
                      <Select
                        value={selectedSector}
                        onChange={handleSectorChange}
                        label="Sector de Actividade"
                      >
                        <MenuItem value="">
                          <em>Selecione um setor</em>
                        </MenuItem>
                        {sectors.map((sector) => (
                          <MenuItem key={sector.value} value={sector.text}>
                            {sector.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth variant="outlined" margin="normal">
                      <InputLabel>Província</InputLabel>
                      <Select
                        value={selectedProvince}
                        onChange={handleProvinceChange}
                        label="Província"
                      >
                        <MenuItem value="">
                          <em>Selecione uma província</em>
                        </MenuItem>
                        {dropdown_province.map((province) => (
                          <MenuItem key={province.value} value={province.text}>
                            {province.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <OlogaButton
                      label="Search"
                      type="submit"
                      icon={<SearchIcon />}
                      mt={3}
                      size="large"
                    />
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
          <Grid item xs={12} md={6}>
            <OlogaButton
              label="Subir Nivel Automaticamente para todos"
              type="button"
              icon={<RefreshIcon />}
              mt={3}
              size="large"
              onClick={async () => {
                const response = await axios.get("candidate/autoUpgradeLevel");
                if (response.status === 200) {
                  toast.success(
                    "Todos os níveis dos candidatos foram actualizados"
                  );
                  navigate(`/candidates/progress`);
                } else {
                  toast.error(
                    "Erro o seguinte erro ao realizar a operação: " +
                      response.data
                  );
                }
              }}
            />
          </Grid>
          <Card>
            <OlogaDataGrid url={url} columns={columns} />
          </Card>
          <OlogaBackButton />
          <OlogaConfirmDialog
            title="Confirmação!"
            description={`Tem Certeza que deseja subir o nível do Candidato ${params?.row?.fullName}`}
            open={openDialog}
            setOpen={setOpenDialog}
            hasCommentBox={true}
            handleConfirm={(commentValue) => {
              setComment(commentValue); // Set the comment
              updateLevel(commentValue); // Proceed with the level update
            }}
          />
          <OlogaConfirmDialog
            title="Confirmação!"
            description={`Tem Certeza que deseja baixar o nível do Candidato ${params?.row?.fullName}`}
            open={openDialogDown}
            setOpen={setOpenDialogDown}
            hasCommentBox={true}
            handleConfirm={(commentValue) => {
              setComment(commentValue); // Set the comment
              downLevel(commentValue); // Proceed with the level downgrade
            }}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default CandidateProgress;
